import PropTypes from 'prop-types';



enum Breakpoint {
	Mobile = 642,
	Desktop = 1168,
	Xlarge = 1440,
}

export enum Viewport {
	Small = 'VIEWPORT_SMALL',
	Medium = 'VIEWPORT_MEDIUM',
	Large = 'VIEWPORT_LARGE',
	Xlarge = 'VIEWPORT_XLARGE',
}

export enum Orientation {
	Landscape = 'LANDSCAPE',
	Portrait = 'PORTRAIT',
}

// Special breakpoint for tabbed view
export const TABBED_VIEW_BREAKPOINT = 830;

/**
 * Phase 3 (expanded sidebar) starts at 1169px (Large+)
 * Phase 2 (56px sidebar) is default for all viewports below Phase 3
 *
 * Determines if the navigation should be in Phase 3 (desktop/expanded).
 *
 * Priority order:
 * 1. Menu minimized state (highest priority - user clicked minimize button)
 * 2. Menu expansion state (user clicked menu item)
 * 3. Natural viewport (lowest priority - viewport size)
 *
 * @param viewportType - Viewport type information
 * @param menuExpanded - Optional: Menu-initiated expansion state (user clicked menu item in Phase 2)
 * @param menuMinimized - Optional: Menu-initiated minimized state (user clicked minimize button in Phase 3)
 */
export function isPhase3(
	viewportType: {
		isLarge: boolean,
		isExtraLarge: boolean,
	},
	menuExpanded?: boolean,
	menuMinimized?: boolean,
): boolean {
	// Priority 1: Menu minimized state (user clicked minimize button - highest priority)
	if (menuMinimized === true) {
		return false;
	}

	// Priority 2: Menu expansion state (user clicked menu item)
	if (menuExpanded === true) {
		return true;
	}

	// Priority 3: Natural viewport determines phase
	return viewportType.isLarge || viewportType.isExtraLarge;
}



export function getCurrentDeviceOrientation(width: number, height: number): Orientation {
	if (width <= height) {
		return Orientation.Portrait;
	}

	return Orientation.Landscape;
}



export function getCurrentViewportSize(width: number): Viewport {
	if (width <= Breakpoint.Mobile) {
		return Viewport.Small;
	} else if (width <= Breakpoint.Desktop) {
		return Viewport.Medium;
	} else if (width <= Breakpoint.Xlarge) {
		return Viewport.Large;
	}

	return Viewport.Xlarge;
}



export function viewportOrientationValidation() {
	return PropTypes.oneOf([
		Orientation.Landscape,
		Orientation.Portrait,
	]);
}



export function viewportTypeValidation() {
	return PropTypes.oneOf([
		Viewport.Small,
		Viewport.Medium,
		Viewport.Large,
		Viewport.Xlarge,
	]);
}
